export default __webpack_public_path__ + "static/media/cityIcon (2).665c2931.svg";